import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=a9f2346a&scoped=true&"
import script from "./PlanCard.vue?vue&type=script&lang=ts&"
export * from "./PlanCard.vue?vue&type=script&lang=ts&"
import style0 from "./PlanCard.vue?vue&type=style&index=0&id=a9f2346a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f2346a",
  null
  
)

export default component.exports